<template>
  <div class="invitation_container">
    <cv-navbar/>

    <div class="container_main">
      <div class="main_header" :style="{backgroundImage: `url(${require('@/static/images/current.png')})`}">

       <div class="header_center">
         <div class="center_avatar"><img :src="personInfo.avatar_url" alt=""></div>
         <div class="center_name"><p>hi～亲爱的 <span>{{personInfo.username}}</span></p></div>
         <!-- <div class="center_desc"><p>成功邀请 <span style="color:#FF6644">3个</span>  好友注册，免费获得 <span style="color:#FF6644">30天</span> 超级会员</p></div> -->
       </div>
      </div>

      <!-- <div class="main_share">
        <div class="share_center">
          <div class="share_url">
            <div class="url_title">我的邀请链接：</div>
            <div class="url_input">
              <input type="text" :placeholder="`${host}/account/users/${data.g_identity}/invite`" disabled="disabled">
            </div>
            <button class="url_copy" @click="copy" :data-clipboard-text="`${host}/account/users/${data.g_identity}/invite`">复制</button>
          </div>

          <div class="share_qrcode">
            <div class="qrcode_title">扫码分享：</div>
            <div class="qrcode_code">
              <div class="code_img">
                <qrcode-vue :value="`${host}/account/users/${data.g_identity}/invite`"
                        :size='90'
                        class="img"/>
              </div>
              <div class="code_desc">扫码分享邀请好友 免费获得超级会员</div>
            </div>
          </div>
          <div class="share_had">
            <p>已有 <span>{{data.invite_count}}个</span> 好友注册，免费获得 <span>{{data.free_day}}天</span> 超级会员</p>
          </div>
        </div>
      </div> -->

      <div class="main_user" style="min-height: 50vh">
        <div class="user_center">
          <div class="center_vip">
           <div class="vip_title">超级优惠券：</div>
            <div class="vip_input">
              <input type="text" :placeholder="text" ref='input' @blur="defaultText" v-model="text" @click="clearDefault">
            </div>
            <div class="vip_copy" @click="exchange">兑换</div>
          </div>
          <div class="center_self" v-if="couponsList.length > 0">
            <div class="self_title">
              <div class="title_1">我的优惠券：</div>
              <div class="title_2 title">优惠券</div>
              <div class="title_3 title">有效期</div>
              <div class="title_4 title">优惠</div>
              <div class="title_5 title">状态</div>
            </div>
            <div class="hr"></div>
            <div class="self_list">
              <div class="list_item" v-for="(item) in couponsList" :key='item.id'>
                <p class="item_1">{{item.name}}</p>
                <p class="item_2">{{item.expiry.substr(0,10)}}</p>
                <p class="item_3" v-if="item.cent">￥{{item.cent / 100}}</p>
                <p class="item_3" v-if="item.discount"> {{item.discount * 10}}折</p>
                <p class="item_3" v-if="item.member_days && item.member_days === 30000">无期限</p>
                <p class="item_3" v-if="item.member_days && item.member_days < 30000"> {{item.member_days}}天</p>
                <p class="item_4">{{item.status}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <pc-footer/>
  </div>
</template>

<script>
  import qrcodeVue from 'qrcode-vue';
  import Clipboard  from 'clipboard';
 	import { get_tUser, routerTo } from '../../assets/js/util'
  import cvNavbar from '@/components/base/navbar';
  import pcFooter from '@/components/base/pcFooter';
  import api from '../../api'
  import {mapState, mapActions} from "vuex"
export default {
  components: {
    cvNavbar,
    pcFooter,
    qrcodeVue
  },
  data () {
    return{
      couponsList: [],
      data: {},
      text:'请输入兑换码',
      host:''
    }
  },
  created (){
    this.host = (window.location.origin).replace(/www/g,'m')
   this.getInfo()
  },
  computed:  {
      ...mapState("me", ["personInfo"])
  },
  methods: {
    // 获取优惠券信息
    async getInfo () {
      let {c_t} = get_tUser()
      let res = await api.account.getInvite(c_t)
      // console.log(res,this.personInfo)
      if (res.code === 1000) {
        this.couponsList = res.data.coupons
        this.data = res.data
      }
    },
    // 输入框清空
    clearDefault (){
      this.text = ''
     /*  let input = this.$refs.input.placeholder
      if(input === '请输入兑换码') {
        this.text = ''
      }else{
        this.text = input
      } */
    },
    // 复制
    copy() {
      let clipboard = new Clipboard('.url_copy');
      clipboard.on('success', e => {
        this.$message.success('复制成功');
        // 释放内存
        clipboard.destroy();
      })
    },
    // 兑换优惠券
    async exchange(){
      let {c_t} = get_tUser()
      let input = this.$refs.input.placeholder
      // console.log(input)
      let datas = {partner: input, coupon_plan:''}
      // if (this.activePic === 99){
      //   datas.coupon_plan = ''
      // }else {
      //   datas.coupon_plan = ''
      // }
      let res  = await api.account.couponsCreate(c_t,datas)
      if (res.code === 1000) {
        // 30000天为终身会员
        if (res.data.code_kind === 'member' && res.data.message.indexOf('30000') > -1) {
          this.$message.success("恭喜成为超级简历终身会员！")
        }else if (res.data.code_kind === 'member') {
          this.$message.success(res.data.message)
        }else {
          this.$message.success(res.data.message)
        }
         /* this.couponsList.unshift(res.data.coupons) */
         this.getInfo()
       } else {
          this.$message.error(res.data ? res.data.error : res.message)
       }
       // console.log(res,this.couponsList)
    },
    // 失去焦点
    defaultText (){
      let input = this.$refs.input.placeholder
      if(input) {
        this.text = input
      }else {
        this.text = '请输入兑换码'
      }
    }
  }

}
</script>

<style lang="scss" scoped>
 .invitation_container {
   width: 100%;
   font-family: PingFangSC-Light,PingFang SC;
   background-color: #fff;
   .container_main {
     margin-top: 56px;
     width: 100%;
     //@at-rootheight: 100%;
     background-color: #fff;
     .main_header {
       width: 100%;
       height: 200px;
       .header_center {
         display: flex;
         //justify-content: center;
         flex-direction: column;
         align-items: center;
         margin: 0 auto;
         width: 604px;
         height: 200px;

         .center_avatar {
           margin-top: 36px;
           width: 48px;
           height: 48px;
           border-radius: 24px;
           img {
             width: 48px;
             height: 48px;
             border-radius: 24px
           }
         }
         .center_name {
           margin-top: 12px;
           width: 500px;
           height: 28px;
           text-align: center;
           font-weight: 300;
           font-size: 16px;
           color:rgba(255,255,255,1);
           span {
             font-weight: 600;
           }
         }
         .center_desc {
           width:620px;
           height:28px;
           font-size:28px;
           font-weight:600;
           color:rgba(255,255,255,1);
           line-height:28px;
         }
       }
     }
     .main_share {
       padding-top: 36px;
       height: 245px;
       width: 100%;
       background:rgba(245,246,250,1);
       .share_center {
         margin: 0 auto;
         width: 703px;
         height: 245px;
         .share_url {
           display: flex;
           align-items: center;
           width: 100%;
           height: 46px;
           line-height: 46px;
           .url_title{
             width:112px;
             height:18px;
             font-size:16px;
             font-weight:400;
             color:rgba(65,70,83,1);
             line-height:18px;
           }
           .url_input {
             width:465px;
             height:46px;
             border-radius:6px;
             background:rgba(254,255,255,1);
             border-radius:6px;
             input {
               box-sizing: border-box;
               padding-left: 24px;
               width:465px;
               height:46px;
               background:rgba(254,255,255,1);
               border-radius:6px;
               height:14px;
               font-size:14px;
               font-weight:400;
               color:rgba(65,70,83,1);
               line-height:14px;
             }
           }
           .url_copy {
               margin-left: 16px;
               width:102px;
               height:46px;
               text-align: center;
               line-height: 46px;
               background:rgba(65,70,83,1);
               border-radius:6px;
               font-size: 18px;
               font-weight:400;
               color:rgba(255,255,255,1);
               cursor: pointer;
           }
         }
         .share_qrcode {
           display: flex;
           align-items: center;
           margin-top: 16px;
           width: 100%;
           height: 120px;
           .qrcode_title {
             width:80px;
             height:18px;
             font-size:16px;
             font-weight:400;
             color:rgba(65,70,83,1);
             line-height:18px;
           }
           .qrcode_code {
             display: flex;
             align-items: center;
             margin-left: 33px;
             width: 583px;
             height: 120px;
             border-radius: 6px;
             background-color: #fff;
             .code_img {
               display: flex;
               align-items: center;
               justify-content: center;
               margin-left: 20px;
               width: 92px;
               height: 92px;
               background-color: #fff;
               .img {
                 width: 92px;
                 height: 92px;
                /deep/  img {

                   width: 92px;
                   height: 92px;
                 }
               }
             }
             .code_desc {
               margin-left: 14px;
               width:262px;
               height:24px;
               font-size:16px;
               font-weight:400;
               color:rgba(65,70,83,1);
               line-height:24px;
             }
           }
         }
         .share_had {
           margin-top: 16px;
           width: 100%;
           //height: 20px;
           p {
             margin-left: 115px;
             width:313px;
             height:16px;
             font-size:16px;
             font-weight:500;
             color:rgba(65,70,83,1);
             line-height:16px;
             span {
               color:#FF6644;
             }
           }
         }
       }
     }
     .main_user {
       //height: 500px;
       box-sizing: border-box;
       padding-top: 36px;
       margin-bottom: 30px;
       width: 100%;
       //height: 375px;
       .user_center {
         margin: 0 auto;
         width: 703px;
         //height: 375px;
         .center_vip {
           display: flex;
           align-items: center;
           width: 100%;
           height: 46px;
           line-height: 46px;
           .vip_title{
             width:112px;
             height:18px;
             font-size:16px;
             font-weight:400;
             color:rgba(65,70,83,1);
             line-height:18px;
           }
           .vip_input {
             width:465px;
             height:46px;
             border-radius:6px;
             background:rgba(254,255,255,1);
             border-radius:6px;
             input {
               box-sizing: border-box;
               padding-left: 24px;
               width:465px;
               height:46px;
               background:rgba(254,255,255,1);
               border-radius:6px;
               height:16px;
               font-size:14px;
               font-weight:400;
               color:#AEB2BD;
               line-height:16px;
             }
           }
           .vip_copy {
               margin-left: 16px;
               width:102px;
               height:46px;
               text-align: center;
               line-height: 46px;
               background:rgba(65,70,83,1);
               border-radius:6px;
               font-size: 18px;
               font-weight:400;
               color:rgba(255,255,255,1);
               cursor: pointer;
           }
         }
         .center_self {
           //overflow: hidden;
           margin-top: 35px;
           width: 100%;
           //height: 293px;
           .self_title {
             display: flex;
             //align-items: center;
             width: 100%;
             height: 34px;
             .title_1 {
               width:96px;
               height:18px;
               font-size:16px;
               font-weight:400;
               color:rgba(65,70,83,1);
               line-height:18px;
             }
             .title {
               height:16px;
               font-size:16px;
               font-weight:500;
               color: rgba(65,70,83,1);;
               line-height:16px;
             }
             .title_2 {
               margin-left: 24px;
               width: 70px;
             }
             .title_3{
               margin-left: 171px;
             }
             .title_4 {
               margin-left: 102px;
             }
             .title_5 {
               margin-left: 84px;
             }

           }
           .hr {
             margin-left: 120px;
             //margin-top: 5px;
             width:583px;
             height:1px;
             background-color: #AEB2BD;
           }
           .self_list {
             margin-left: 120px;
             margin-top: 17px;
             width:583px;
             //height: 220px;
             .list_item {
               margin-top: 16px;
               display: flex;
               height: 14px;
               font-size:14px;
               font-weight:400;
               color:#414653;
               .title {
                 width: 150px;
               }
               .item_1 {
                 width:157px;
               }
               .item_2 {
                 margin-left: 84px;
                 width:89px;
               }
               .item_3 {
                 margin-left: 63px;
                 width:50px;
               }
               .item_4 {
                 margin-left: 63px;
                 width:50px;
               }
             }
           }
         }
       }
     }
   }
 }
</style>
